import script from "./TheButtonGhost.vue?vue&type=script&setup=true&lang=js"
export * from "./TheButtonGhost.vue?vue&type=script&setup=true&lang=js"

import "./TheButtonGhost.vue?vue&type=style&index=0&id=419a4ebe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419a4ebe"]])

export default __exports__